import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { LoginService } from '../login.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(LoginService);
    const router = inject(Router);

    if (req.url.endsWith('.html') || req.url.endsWith('.htm')) { return next(req); }

    // Clone the request object
    // Get the access token dynamically
    const token = authService.accessToken;


    // Clone the request to modify headers
    let headersConfig: { [name: string]: string | string[] } = {
        'Accept': 'application/json',
    };

    // Check if the request body is FormData (typically for file uploads).
    const isFormData = req.body instanceof FormData;

    // Only set the 'Content-Type' header if the body is NOT FormData.
    // For FormData, the browser will automatically set the correct 'Content-Type' including the boundary.
    if (!isFormData) {
        headersConfig['Content-Type'] = 'application/json';
    }

    // Clone the request and set withCredentials to true for cookie support
    let newReq = req.clone({
        setHeaders: headersConfig,
        withCredentials: true
    });

    // Response
    return next(newReq).pipe(
        catchError((error) => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // Only sign out if not already logging out (prevents multiple logout calls)
                if (!authService.isLoggingOut) {
                    authService.signOut().subscribe();
                }
            } else if (error instanceof HttpErrorResponse && error.status === 404) {
                // Sign out
                router.navigate(['authentication/error404']);
            }
            else if (error instanceof HttpErrorResponse && error.status === 500) {
                // Sign out
                router.navigate(['authentication/maintenance']);
            }
            else if (error instanceof HttpErrorResponse && error.status === 0) {
                // Sign out
                router.navigate(['authentication/maintenance']);
            }

            return throwError(error);
        })
    );
};
